import React from "react";
import img from "../../../assets/_home/popularCollection3.png";
import styles from "./History.module.scss";

const History = () => {
  return (
    <div className={styles.container}>
      <div className={styles.history}>
        <img src={img} alt="item" />

        <div className={styles.text}>
          <p>Listed 1 edition for 0.56 sol</p>
          <small>By Cryptographics</small>
        </div>

        <div className={styles.date}>
          <small>10/02/2022</small>
        </div>
      </div>

      <div className={styles.history}>
        <img src={img} alt="item" />

        <div className={styles.text}>
          <p>Listed 1 edition for 0.56 sol</p>
          <small>By Cryptographics</small>
        </div>

        <div className={styles.date}>
          <small>10/02/2022</small>
        </div>
      </div>
    </div>
  );
};

export default History;
